import React, {
  createContext,
  useContext,
  useState,
  useEffect
} from 'react';

import { useAuth } from './AuthContext';

import {
  apiGetUserUiProps,
  apiPutUserUiProps
} from '../utils/api';

const PreferencesContext = createContext();

const STORAGE_KEY = 'klaes_preferences';

const DEFAULT_PREFS = {
  accentColor: '#6366f1',
  fontSize: 100
};

export const PreferencesProvider = ({ children }) => {
  const { token } = useAuth();

  const [preferences, setPreferences] =
    useState(DEFAULT_PREFS);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {
    if (!token) {
      applyPreferencesToCss(DEFAULT_PREFS);
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        const data =
          await apiGetUserUiProps(token);

        const prefs = {
          ...DEFAULT_PREFS,
          ...(data.ui_props || {})
        };

        setPreferences(prefs);
        applyPreferencesToCss(prefs);
      } catch (err) {
        console.error(err);

        applyPreferencesToCss(DEFAULT_PREFS);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [token]);

  const savePreferences = async (newPrefs) => {
    setPreferences(newPrefs);

    applyPreferencesToCss(newPrefs);

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(newPrefs)
    );

    if (token) {
      try {
        await apiPutUserUiProps(
          token,
          newPrefs
        );
      } catch (err) {
        console.error(
          'UI Props speichern fehlgeschlagen',
          err
        );
      }
    }
  };

  const resetToDefault = async () => {
    await savePreferences(DEFAULT_PREFS);
  };

  return (
    <PreferencesContext.Provider
      value={{
        preferences,
        savePreferences,
        resetToDefault,
        loading
      }}
    >
      {children}
    </PreferencesContext.Provider>
  );
};

function applyPreferencesToCss(prefs) {
  document.body.style.setProperty(
    '--user-accent',
    prefs.accentColor
  );

  document.body.style.setProperty(
    '--user-accent-light',
    prefs.accentColor
  );

  document.body.style.setProperty(
    '--user-accent-dark',
    prefs.accentColor
  );

  const baseSize =
    (prefs.fontSize / 100) * 16;

  document.documentElement.style.setProperty(
    '--base-font-size',
    `${baseSize}px`
  );
}

export const usePreferences = () =>
  useContext(PreferencesContext);